// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".easyscreen-fullscreen-button{position:absolute;top:20px;right:20px;z-index:100;height:77px;width:77px;background-image:url(/images/icon/fullscreenBtn.png);background-repeat:no-repeat;background-size:100% 100%;background-position:50%}", ""]);
// Exports
module.exports = exports;
